import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class WaterSurfaceStressCalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (WaterSurfaceStressCalculationMethodModel._instance == null) WaterSurfaceStressCalculationMethodModel._instance = new WaterSurfaceStressCalculationMethodModel(authManager);
        return WaterSurfaceStressCalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/water-surface-stress-calculation-methods', 'geo-sections/water-surface-stress-calculation-methods/codelist');

        this.entityName = 'geo-sections.WaterSurfaceStressCalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Water Surface Stress Calc Method';
        this.setLabel = 'Water Surface Stress Calc Methods';

        this.browser = {
            name: 'default-geo-sections-watersurfacestresscalculationmethod-browser',
            moduleName: 'default-geo-sections-watersurfacestresscalculationmethod-browser',
            moduleTitle: 'Water Surface Stress Calc Methods',
            moduleStateSlotName: 'default-geo-sections-watersurfacestresscalculationmethod-browser',
        };

        this.editor = {
            name: 'default-geo-sections-watersurfacestresscalculationmethod-editor',
            moduleName: 'default-geo-sections-watersurfacestresscalculationmethod-editor',
            moduleTitle: 'Water Surface Stress Calc Method',
            moduleStateSlotName: 'default-geo-sections-watersurfacestresscalculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
